import React from 'react';
import {
  Box,
  Typography,
  Divider,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ScheduleIcon from '@mui/icons-material/Schedule';
import FavoriteIcon from '@mui/icons-material/Favorite';

function BriefingFooterSections({
  recent_cancellations,
  end_of_day_ritual,
  done_enough_nudge,
  year_end_reflection,
  onOpenReflection,
}) {
  return (
    <>
      {recent_cancellations?.length > 0 && (
        <>
          <Divider />
          <Box sx={{ p: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Recent Cancellations
            </Typography>
            <List dense disablePadding>
              {recent_cancellations.map((cancellation, idx) => (
                <ListItem key={idx} disablePadding sx={{ mb: 0.5 }}>
                  <ListItemIcon sx={{ minWidth: 28 }}>
                    <ScheduleIcon fontSize="small" color="warning" />
                  </ListItemIcon>
                  <ListItemText
                    primary={cancellation.message}
                    primaryTypographyProps={{ variant: 'body2' }}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        </>
      )}

      {end_of_day_ritual?.show_ritual && (
        <>
          <Divider />
          <Box sx={{ p: 2, bgcolor: 'primary.50', borderRadius: 1, m: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <FavoriteIcon fontSize="small" color="primary" sx={{ mt: 0.25 }} />
              <Box>
                <Typography variant="body2" fontWeight={500}>
                  {end_of_day_ritual.prompt}
                </Typography>
                <Button
                  size="small"
                  variant="text"
                  sx={{ mt: 1, textTransform: 'none' }}
                  onClick={() => onOpenReflection('closure')}
                >
                  Take a brief reflection
                </Button>
              </Box>
            </Box>
          </Box>
        </>
      )}

      {done_enough_nudge?.show_nudge && (
        <>
          <Divider />
          <Box sx={{ p: 2, bgcolor: 'success.50', borderRadius: 1, m: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CheckCircleIcon fontSize="small" color="success" />
              <Typography variant="body2">
                {done_enough_nudge.message}
              </Typography>
            </Box>
          </Box>
        </>
      )}

      {year_end_reflection?.show_reflection && (
        <>
          <Divider />
          <Box sx={{ p: 2, bgcolor: 'info.50', borderRadius: 1, m: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <FavoriteIcon fontSize="small" color="info" sx={{ mt: 0.25 }} />
              <Box>
                <Typography variant="body2" fontWeight={500} gutterBottom>
                  {year_end_reflection.prompt}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  {year_end_reflection.impact_message}
                </Typography>
                <Button
                  size="small"
                  variant="text"
                  sx={{ textTransform: 'none' }}
                  onClick={() => onOpenReflection('year_reflection', year_end_reflection.impact_message)}
                >
                  Reflect on the year
                </Button>
              </Box>
            </Box>
          </Box>
        </>
      )}
    </>
  );
}

export default BriefingFooterSections;
